import { Command } from 'commander';
import api from '../services/api';
import { bookNameSchema } from '../models';
import asyncErrorWrapper from '../utils/async-error-wrapper';
import output from '../utils/output-writer';

const getPlaybook = new Command('get-playbook')
  .description(
    'Fetch a playbook by book name. Currently only fetches playbooks visible to all users.'
  )
  .requiredOption('-n, --name <name>', bookNameSchema.description)
  .action(
    asyncErrorWrapper(async ({ name }: { name: string }) => {
      const result = await api.getPlaybook({ name });
      output.info(JSON.stringify(result, null, 2));
    })
  );

export default getPlaybook;
